import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { billyVariables } from './assets/billy-theme';
import { frodaVariables } from './assets/froda-theme';
import { kontistVariables } from './assets/kontist-theme';
import { lunarVariables } from './assets/lunar-theme';
import { swedbankPayVariables } from './assets/swedbank-pay-theme';
import { vismaVariables } from './assets/visma-theme';
import { vividVariables } from './assets/vivid-theme';
import { wamoVariables } from './assets/wamo-theme';
import { worldlineSeVariables } from './assets/worldline-se-theme';
import { yabieVariables } from './assets/yabie-theme';

@Injectable()
export class TailwindThemeService {
	constructor(@Inject(DOCUMENT) private readonly document: Document) {}

	loadConfig() {
		const theme = this.getTheme();
		this.updateThemeVariables(theme);
	}

	getTheme() {
		const path = this.document.location.pathname;
		switch (true) {
			case path.includes('swedbank'):
				return swedbankPayVariables;
			case path.includes('yabie'):
				return yabieVariables;
			case path.includes('lunar'):
				return lunarVariables;
			case path.includes('kontist'):
				return kontistVariables;
			case path.includes('testifylending'):
				return kontistVariables;
			case path.includes('shine'):
				return kontistVariables;
			case path.includes('visma'):
				return vismaVariables;
			case path.includes('billy'):
				return billyVariables;
			case path.includes('wamo'):
				return wamoVariables;
			case path.includes('vivid'):
				return vividVariables;
			case path.includes('worldline'):
				return worldlineSeVariables;
			// TODO(TE-5771): Froda variables stand in until SevDesk's brand guide arrives.
			case path.includes('sevdesk'):
				return frodaVariables;
			default:
				return frodaVariables;
		}
	}

	getThemeByName(name: string) {
		let theme;
		switch (name) {
			case 'swedbank-pay':
				theme = swedbankPayVariables;
				break;
			case 'yabie':
				theme = yabieVariables;
				break;
			case 'lunar':
				theme = lunarVariables;
				break;
			case 'lunar-se':
				theme = lunarVariables;
				break;
			case 'kontist':
				theme = kontistVariables;
				break;
			case 'testifylending':
				theme = kontistVariables;
				break;
			case 'shine':
				theme = kontistVariables;
				break;
			case 'billy':
				theme = billyVariables;
				break;
			case 'visma':
				theme = vismaVariables;
				break;
			case 'wamo':
				theme = wamoVariables;
				break;
			case 'vivid':
				theme = vividVariables;
				break;
			case 'worldline-se':
				theme = worldlineSeVariables;
				break;
			// TODO(TE-5771): Froda variables stand in until SevDesk's brand guide arrives.
			case 'sevdesk':
				theme = frodaVariables;
				break;
			default:
				theme = frodaVariables;
				break;
		}
		return theme;
	}

	updateThemeVariables(theme) {
		for (const [name, color] of Object.entries(theme)) {
			this.document.documentElement.style.setProperty(`--${name}`, color as string);
		}
	}
}
